"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Code = styled_components_1.default.p.attrs({
    className: "Code",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: \"Source Code Pro\";\n  color: var(--steel);\n  font-size: ", ";\n  font-weight: var(--font-weight-regular);\n  line-height: 1.5;\n  margin-top: ", ";\n  margin-bottom: ", ";\n  background: var(--smoke);\n  padding: 0 0.4rem;\n  display: inline-block;\n  border-radius: 3px;\n"], ["\n  font-family: \"Source Code Pro\";\n  color: var(--steel);\n  font-size: ", ";\n  font-weight: var(--font-weight-regular);\n  line-height: 1.5;\n  margin-top: ", ";\n  margin-bottom: ", ";\n  background: var(--smoke);\n  padding: 0 0.4rem;\n  display: inline-block;\n  border-radius: 3px;\n"])), function (props) {
    return (props.size && "var(--font-size-" + props.size + ")") || "inherit";
}, function (props) {
    return (props.size && "calc(var(--font-size-" + props.size + ") / 1.125)") ||
        "calc(var(--font-size-xl) / 1.125)";
}, function (props) {
    return (props.size && "calc(var(--font-size-" + props.size + ") * 0.25)") ||
        "calc(var(--font-size-xl) * 0.25)";
});
var templateObject_1;
